import React, { useState, useEffect, useContext } from 'react';
import * as Router from 'react-router-dom';
import MDX from '@mdx-js/runtime';
import { MDXProvider } from '@mdx-js/react';
import { State } from 'react-powerplug';
import Axios from 'axios';
import Moment from 'moment';
import Lodash from 'lodash';

import * as COM from '.';
import * as SYS from '../system';
import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';
import { AuthContext } from '../../containers/App';

export const Form = (props) => {
  const [form] = Antd.Form.useForm();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const auth = useContext(AuthContext);

  let history = Router.useHistory();

  const fetchFormData = async () => {
    try {
      let response = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/forms`, {
        params: {
          filter: {
            where: {
              code: props.form
            }
          }
        }
      });
      // response.data[0].decodedContent = atob(response.data[0].content);
      response.data[0].decodedContent = SYS.fromBinaryV2(response.data[0].content);
      setFormData(response.data[0]);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  };

  const init = async () => {
    setLoading(true);
    await fetchFormData();
    setLoading(false);
  }

  useEffect(() => {
    init();
  }, []);

  const formItemlayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };

  const tailLayout = {
    wrapperCol: { offset: 10, span: 4 },
  };

  const cleanEmptyOrUndefined = (obj) => {
    for (let key of Object.keys(obj)) {
      let value = obj[key];
      let type = typeof value;
      // clean empty object only but not moment instance
      if (type === "object" && !(value instanceof Moment) && value !== null && !Array.isArray(value)) {
        cleanEmptyOrUndefined(value);
        if (!Object.keys(value).length) {
          delete obj[key]
        }
        // clean empty array only
      } else if (Array.isArray(value) && value.length < 1) {
        delete obj[key];
        // clean undefined or null
      } else if (type === "undefined" || value === null) {
        delete obj[key];
      }
    }
  }

  const onFinish = async (confimedData) => {
    cleanEmptyOrUndefined(confimedData);
    let msg = Antd.message.loading('Processing...')
    try {
      let { data } = await Axios.post(`${process.env.REACT_APP_API_BASE_URI}/api/action/${formData.action}`, confimedData, {
        headers: {
          Authorization: `Bearer ${auth.accessToken}`
        }
      });
      
      if (data.message && data.type === undefined) {
        msg.then(() => Antd.message.info(data.message));
      } else if (data.message && data.type === 'success') {
        msg.then(() => Antd.message.success(data.message));
      } else if (data.message && data.type === 'warning') {
        msg.then(() => Antd.message.warning(data.message));
      } else if (data.message && data.type === 'error') {
        msg.then(() => Antd.message.error(data.message));
      } else {
        msg.then(() => { });
      }
      
      if (data.redirect) {
        history.replace(data.redirect);
      }
      
      props.onSuccess && props.onSuccess(data);
    } catch (err) {
      console.log(err)
      msg.then(() => Antd.message.error('Oops, something went wrong!'));
    }
  }

  const initialValues = props.initialValues;

  return (
    <Antd.Form
      form={form}
      onFinish={onFinish}
      initialValues={props.initialValues}
      layout={formData.layout}
      wrapperCol={formData.layout === 'horizontal' ? formItemlayout.wrapperCol : null}
      labelCol={formData.layout === 'horizontal' ? formItemlayout.labelCol : null}
    >
      <MDXProvider>
        <MDX
          components={{
            State
          }}
          scope={{
            COM,
            Antd,
            AntdIcons,
            Moment,
            Lodash,
            initialValues,
            form,
            userProfile: auth.userProfile,
          }}
        >
          {formData.decodedContent}
        </MDX>
      </MDXProvider>

      <Antd.Row
        gutter={8}
        justify="center"
      >
        <Antd.Col>
          <Antd.Form.Item>
            <Antd.Button
              htmlType="submit"
              type="primary"
              style={{
                width: 150
              }}
              {...props.submitButtonProps}
            >
              {props.submitButtonTitle
                ? props.submitButtonTitle
                : 'Send'}
            </Antd.Button>
          </Antd.Form.Item>
        </Antd.Col>
        {props.extraButtons
          ? props.extraButtons.map((child) => (
            <Antd.Col>
              {child}
            </Antd.Col>
          ))
          : null}
      </Antd.Row>
    </Antd.Form>
  );
};
